export default {
  CaregiverMatchingStep: {
    RequestProfilesButton: 'Finish',
  },
  NextStepsSection: {
    Title: 'Next Steps',
    ReviewTitle: 'Caregiver profile review',
    ReviewSubtitle: 'Within 3-5 days',
    MeetTitle: 'Meet & greet',
    StartTitle: 'Start date',
    DateNotSet: 'Date not set',
  },
  WhatHappensCard: {
    Title: 'What happens next',
    DescriptionLine1: 'The right fit, for the long run. You will find a caregiver match with the right skills, availability, and personality for your loved one.',
    DescriptionLine2: 'We will send you caregiver profiles to review.',
  },
  WorksCard: {
    Title: 'Why this works',
    Description: 'Our "mutual opt-in" approach means your caregivers have chosen your family as much as you\'ve chosen them, fostering a deep bond of trust and consistency from day one.',
  },
};
